import { render, staticRenderFns } from "./EditorSimple.vue?vue&type=template&id=655a7667&"
import script from "./EditorSimple.vue?vue&type=script&lang=js&"
export * from "./EditorSimple.vue?vue&type=script&lang=js&"
import style0 from "./EditorSimple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports